import { useEffect, useState } from "react";
import "../styles/styles.css";
import ProjectCard from './../common/components/mp/project';
import Slider from './../common/components/slider/Slider';
const MpNotion = () => {  // ← Remove 'async' here!
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/api/query-notion', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            page_size: 100 // Changed from dataSourceId
          })
        });
        if(!response.ok){
          throw new Error("Failed to fetch events");
        }
        const result = await response.json();
        console.log(result);
        setData(result);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  //const columns = Object.keys(data[0]).filter((key) => key !== "id");
const awardedProjects = data.filter(
  p => p.awards && p.awards.length > 0
);
const topAwardedProjects = [...awardedProjects]
  .filter(p => p.eventName) 
  .sort((a, b) => new Date(b.date) - new Date(a.date))
  .slice(0, 3);
const topAwardedIds = new Set(topAwardedProjects.map(p => p.id));

const remainingProjects = data.filter(
  p => !topAwardedIds.has(p.id) && p.eventName
);

const projectsByYear = remainingProjects.reduce((acc, project) => {
  const year = project.date
    ? new Date(project.date).getFullYear()
    : "Other";

  if (!acc[year]) acc[year] = [];
  acc[year].push(project);
  return acc;
}, {});
const sortedYears = Object.keys(projectsByYear)
  .sort((a, b) => b - a);
Object.values(projectsByYear).forEach(projects => {
  projects.sort((a, b) => {
    const aHasAwards = a.awards.length > 0;
    const bHasAwards = b.awards.length > 0;

    // Awarded projects first
    if (aHasAwards !== bHasAwards) {
      return bHasAwards - aHasAwards;
    }

    // Then by date (newest first)
    return new Date(b.date) - new Date(a.date);
  });
});

  return (
  <div className="container">
  <h3>A LOOK BACK</h3>
  {topAwardedProjects.length > 0 && (
    <div>
      <h2 className="section-title">Recently Awarded Projects</h2>

      {topAwardedProjects.map(project => (
        <ProjectCard
          key={project.id}
          title={project.eventName}
          subtitle={`Awards: ${project.awards.join(", ")}`}
          date={project.date ? project.date.slice(0, 4) : undefined}  
          desc={project.blurb}
          image={project.image}
        />
      ))}
    </div>
  )}
  <h2 className="section-title">Other Projects</h2>
  {sortedYears
    .filter(year => projectsByYear[year].length > 0)  // ← skip empty buckets
    .map(year => (
      <details key={year} className="year-group">
        <summary>{year}</summary>
        {projectsByYear[year].map(project => (
          <ProjectCard
            key={project.id}
            title={project.eventName}
            subtitle={(project.awards.length === 0) ? "" : "Awards: " + project.awards.join(", ")}
            date={project.date ? project.date.slice(0, 4) : undefined}
            desc={project.blurb}
            image={project.image}
          />
        ))}
      </details>
  ))}
</div>    
  );
};

export default MpNotion;